import React from 'react';
import Leaderboard from './Leaderboard';

function App() {
  return (
    <Leaderboard />
  );
}

export default App;
